import { motion } from "framer-motion";

interface ProgressRingProps {
  pct: number;
  size?: number;
  stroke?: number;
  label?: string;
}

export function ProgressRing({ pct, size = 112, stroke = 7, label }: ProgressRingProps) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  return (
    <div data-testid="progress-ring" className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90" aria-hidden>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(71,85,105,0.3)" strokeWidth={stroke} />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#FF5B00"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c * (1 - pct / 100) }}
          transition={{ delay: 0.3, duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          style={{ filter: "drop-shadow(0 0 10px rgba(255,91,0,0.55))" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center leading-none">
        <span data-testid="progress-ring-value" className="font-display text-2xl font-bold tracking-tight text-white">{pct}%</span>
        {label && <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-cad">{label}</span>}
      </div>
    </div>
  );
}
